var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question",class:[{ 'is_finish': _vm.isFinish }]},[_c('div',{staticClass:"content_wrap"},[_c('div',{staticClass:"contents_text rb",domProps:{"innerHTML":_vm._s(_vm.headerText)}})]),_vm._v(" "),_vm._t("btn")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6872a664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcomeCall/Question.vue
// module id = null
// module chunks = 